var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("img", {
      attrs: {
        src: require(`../../../../assets/images/error@2x.jpg`),
        srcset: `${require(`../../../../assets/images/error@1x.jpg`)} 1x, ${require(`../../../../assets/images/error@2x.jpg`)} 2x, ${require(`../../../../assets/images/error@3x.jpg`)} 3x, ${require(`../../../../assets/images/error@4x.jpg`)} 4x`,
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-body" }, [
      _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Timeout")))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm._f("trans")(
              "We're sorry, but your creation has exceeded the processing time. "
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [
          _vm._v(_vm._s(_vm._f("trans")("No Credit has been deducted."))),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("trans")("Please try again later.")) +
            "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }